import { css } from "styled-components/macro";
import { COLUMN_GUTTER_WIDTH_PX } from "./columnLayoutConstants";

/** Shared resize-gutter visuals for multiverse column flex rows. */
export const columnResizeHandleStyles = css`
  .resize-handle {
    top: 0;
    height: 100%;
    width: ${COLUMN_GUTTER_WIDTH_PX}px;
    opacity: 0;
    z-index: 99; /* Below MenuPopover portals (100); active dragging is raised separately. */
    touch-action: none;
    cursor: col-resize;
    pointer-events: auto;

    &:before {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 3px;
      border-radius: 20px;
      background-color: var(--primary-cta-transparent-15);
      top: 25px;
      bottom: 28px;
      opacity: 0;
      transition: opacity 0.15s ease;
    }

    &:hover,
    &.isHovered,
    &.isResizing {
      opacity: 1;

      &:before {
        opacity: 1;
      }
    }

    &.isResizing {
      z-index: 10001; /* Above menu during active drag */
      overflow: visible;
      &:after {
        content: "";
        position: fixed;
        width: 500000px;
        height: 500000px;
        background-color: transparent;
        z-index: 10001;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
      }
    }
  }

  > .resize-handle.column-gutter-between {
    position: absolute;
    margin: 0;
    min-width: 0;
  }

  /* Overlay gutters on the center column so flex math stays left + center + right. */
  > .resize-handle.column-gutter-between.resize-handle-left {
    left: 0;
  }

  > .resize-handle.column-gutter-between.resize-handle-right {
    left: calc(var(--center-column-width, 0px) - ${COLUMN_GUTTER_WIDTH_PX}px);
  }
`;
